import { FormInstance } from "antd/lib/form";
import { RefundRequestConfirmPayload } from "models";
import React from "react";

export const EditableContext = React.createContext<FormInstance<RefundRequestConfirmPayload> | undefined>(undefined);
